export class mdlBindInfo_MotorCancel_Req{
    public PolicyNo:string;
    public RegNo:string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlBindInfo_MotorCancel_Req.ts